module.exports = __webpack_public_path__ + "static/media/onboarding-what-to-expect-line-horizontal.44deec77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-what-to-expect-line-horizontal.svg
// module id = 690
// module chunks = 0